import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'

function fetchSounds () {
  return axios.get(`${CRM_API_URL}/sounds`).then((response) => response.data.data)
}

export default { fetchSounds }
